/**
 * Hobby "Get started" (opens app) is for free-tier users only. Hide it when the user already
 * has consumer Pro or a paid organization plan.
 */
export function shouldShowHobbyOpenAppCta(
  consumerPlanTier: 'FREE' | 'PRO',
  orgPlanTier: string | null,
): boolean {
  if (consumerPlanTier === 'PRO') return false
  if (orgPlanTier === 'PRO' || orgPlanTier === 'BUSINESS' || orgPlanTier === 'ENTERPRISE') return false
  return true
}
